// libs
import React from 'react';

import { getSanitisedUrl } from '@lyearn/core/utils/url';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
// components
import { LinkButton } from '@lyearn/ui';

// content
import { useProviderContent } from '../context';
// types
import { LinkProps } from '../types';
import { LinkBtn } from './styles';

const linkClasses = {
  label: 'body-short-02 text-text-secondary',
};

function Link({ className }: LinkProps) {
  const { t } = useTranslation();
  const { provider } = useProviderContent();

  if (!provider?.url) {
    return null;
  }

  return (
    <LinkButton
      className={cn('py-2 px-4', className, LinkBtn)}
      classes={linkClasses}
      color={'internal'}
      href={getSanitisedUrl(provider.url)}
      rel="noreferrer"
      target="_blank">
      {t('ExternalContent:Details.VisitWebsite')}
    </LinkButton>
  );
}

export default React.memo(Link);
